// 最小ハッシュルーター（外枠）。#/<id> でモジュールを切り替える。
export function createRouter(validIds, onChange) {
  const fallback = validIds[0]
  // 外部画面（得意先向け・ログイン不要）。main.js が起動時に分岐するためルーターに描画手段が無い。
  // 実行中アプリで踏んだ場合、URL は一切書き換えず（token 付きURLを保全）**完全リロード**して
  // main.js の起動時分岐に処理を渡す。これで新規タブで開いた時と同じ結果になる。
  // 従来（PR #47）は URL 保全だけで fallback を描いていたため、URL は #/approve のまま
  // 社内シェル（ダッシュボード）が出る食い違いが残っていた（2026-08-27 本番実測で再現）。
  const externalIds = ['approve', 'request']
  function rawOf() {
    return (location.hash || '').replace(/^#\/?/, '').split('?')[0]
  }
  function current() {
    const hash = location.hash || ''
    const raw = rawOf()
    // 受付(intake)はNAVから削除し配車・受注へ統合した。ただし #/intake?open=<id>
    // （仮受付/正式行クリック時にPR②③で確立した「受付フォームを開く」内部遷移）は
    // 引き続き intake.js を描画させ、直接アクセス（クエリ無し）だけ dispatch へ流す。
    // 設計: engineering-タクミ/docs/2026-08-25-受付配車受注統合-設計.md PR④
    if (raw === 'intake') return /[?&]open=/.test(hash) ? 'intake' : 'dispatch'
    // 請求書（invoice）も NAV に出さない帳票ルート。得意先と月を指す
    // #/invoice?m=YYYY-MM&k=<集計キー> のときだけ描画し、クエリ無しの直接アクセスは
    // 請求・支払（billing）へ内部リダイレクトする（intake と同じ扱い。設計:
    // engineering-タクミ/docs/2026-08-28-請求書発行-設計.md §7）
    if (raw === 'invoice') return /[?&]m=/.test(hash) ? 'invoice' : 'billing'
    return validIds.includes(raw) ? raw : fallback
  }
  function handle() {
    const raw = rawOf()
    // 外部画面へ遷移した: URL はそのままに完全リロードし、main.js の起動時分岐へ渡す。
    // ループしない理由: 起動時ハッシュが外部なら main.js は startApp（＝createRouter）に
    // 到達しないため、リロード後にこの handle() は存在しない。
    if (externalIds.includes(raw)) { location.reload(); return }
    const id = current()
    // 未登録ハッシュ（#/intake 直接・#/存在しない 等）は URL も既定ルートへ是正する
    // （2026-08-26 実画面総点検 問題4: fallback は描画されるのに URL だけ残り、表示と食い違う）。
    // location.replace で履歴を汚さない。replace が hashchange を再発火し、その回で描画される。
    // 対象は「#/ 始まりで解決先とズレたもの」だけ。#access_token= 等の認証系ハッシュの
    // URL は従来どおり書き換えない。外部画面（approve/request）は上で return 済み。
    if (raw !== id && (location.hash || '').startsWith('#/')) {
      location.replace('#/' + id)
      return
    }
    onChange(id)
  }
  window.addEventListener('hashchange', handle)
  return {
    start() { if (!location.hash) location.hash = '#/' + fallback; handle() },
    current,
  }
}
